import React from "react";
import logo from "../../assets/logo.png";

export const Logo = () => {
  return <img src={logo} width={50} height={50} alt="Avatar" />;
};
